import { Card, Typography, Chip } from '@material-tailwind/react'
import { useSelector } from 'react-redux'

export const UserInfo = () => {
  const { current: currentUser } = useSelector(state => state.user)

  return (

    <Card className='flex items-start justify-between px-4 py-3 shadow-none'>
      <section className='flex flex-col gap-1'>
        <Typography variant='paragraph' className='text-sm font-semibold text-gray-700'>{currentUser?.name}</Typography>
        <Typography variant='paragraph' className='text-xs font-normal text-gray-500 truncate'>{currentUser?.email}</Typography>
        <div>
          {(currentUser?.roles || []).map(role => (
            <Chip
              key={role.id}
              className='w-fit rounded-full text-slate-700 text-xs font-medium normal-case bg-gray-100'
              size='sm'
              value={role.nameText}
            />
          ))}
        </div>
      </section>
    </Card>
  )
}
